const avtoPathesHead = {
  city: (data, p) => ({
    header: `Купить мототехнику бу ${p.inCity}`,
    header_uk: `Купити мототехніку бу ${p.inCity}`,

    title: `Мототехника ${p.t(data.city)}. Продажа поддержанной мототехники - Автобазар`,
    title_uk: `Мототехніка ${p.t(data.city)}. Продаж підтриманої мототехнікі - Автобазар`,

    description: `Купить мототехнику бу ${p.inCity}. Продажа поддержанной мототехники на Автобазар. Большой выбор объявлений. Сравнить цены. Проверенные продавцы`,
    description_uk: `Купити мототехніку бу ${p.inCity}. Продаж підтриманої мототехніки на Автобазар. Великий вибір оголошень. Порівняти ціни. Перевірені продавці`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/templates.js